import DashboardActions from '../../../../actions/DashboardActions';
import moment from 'moment';
import config from '../../../../config';
import store from '../../../../stores/redux';
import {metrics} from "../../../../utils/ReportComponent/config";

export const actions = {
    getData() {

        const user = store.getState().user;

        //dashboard show only visible metric
        let columns = [];
        Object.keys(metrics).map(function (metric) {
            if (true === metrics[metric].visible) {
                columns.push(metric);
            }
        });

        let params = {
            publishers: [],
            group_by: 'Day',
            from_day: moment.utc().startOf('day').subtract(1, 'days').format(config.reportDateFormat),
            to_day: moment.utc().endOf('day').format(config.reportDateFormat),
            timezone: 'UTC', // dashboard data are shown in UTC (see the note under "Last 7 days")
            currency: user?.publisher?.account?.balance?.currency || 'USD',
            columns: columns,
            totals: '1'
        };

        return DashboardActions.getTodayData(params).catch(err => {
            console.warn('DashboardToday getData error:', err);
            throw err;
        });
    }
};
